export const version = '2.31.0';
//# sourceMappingURL=version.js.map